import { useEffect } from 'react';
import { SIGN_IN_VIEW } from 'common/constants/auth';
import type { UseRouteAuthErrorToActiveStepParams } from './useRouteAuthErrorToActiveStep.types';

const useRouteAuthErrorToActiveStep = ({
  authError,
  clearIdentifierServerError,
  clearPasswordServerError,
  clearTermsServerError,
  identifierForm,
  passwordForm,
  termsForm,
  view,
}: UseRouteAuthErrorToActiveStepParams) => {
  useEffect(() => {
    clearIdentifierServerError();
    clearPasswordServerError();
    clearTermsServerError();

    if (!authError) {
      return;
    }

    switch (view) {
      case SIGN_IN_VIEW.IDENTIFIER:
        identifierForm.setError('identifier', { message: authError, type: 'server' });
        break;
      case SIGN_IN_VIEW.PASSWORD:
        passwordForm.setError('password', { message: authError, type: 'server' });
        break;
      case SIGN_IN_VIEW.TERMS:
        termsForm.setError('acceptTerms', { message: authError, type: 'server' });
        break;
      default:
        break;
    }
  }, [
    authError,
    clearIdentifierServerError,
    clearPasswordServerError,
    clearTermsServerError,
    identifierForm,
    passwordForm,
    termsForm,
    view,
  ]);
};

export default useRouteAuthErrorToActiveStep;
